export const translationKeys = {
    "de": {
        "open": "Öffnen",
        "isOpen": "geöffnet",
        "close": "Schliessen",
        "isClosed": "geschlossen",
        "isAvailable": "verfügbar",
        "isNotAvailable": "nicht verfügbar",
        "closedTemp": "Vorübergehend Geschlossen",
        "venueCurrentlyOpen": "Das Restaurant ist zur Zeit geöffnet.",
        "willCloseAt": "Schliesst regulär heute um {{ todaysCloseTime }}",
        "willOpenAt": "Öffnet regulär wieder morgen um {{ todaysOpenTime }}",
        "venueCurrentlyClosed": "Das Restaurant ist zur Zeit geschlossen.",
        "overnightIndicator": "bis nächster Tag",
    },
    "en": {
        "open": "Öffnen",
        "isOpen": "geöffnet",
        "close": "Schliessen",
        "isClosed": "geschlossen",
        "isAvailable": "verfügbar",
        "isNotAvailable": "nicht verfügbar",
        "closedTemp": "Vorübergehend Geschlossen",
        "venueCurrentlyOpen": "Das Restaurant ist zur Zeit geöffnet.",
        "willCloseAt": "Schliesst regulär heute um {{ todaysCloseTime }}",
        "willOpenAt": "Öffnet regulär wieder morgen um {{ todaysOpenTime }}",
        "venueCurrentlyClosed": "Das Restaurant ist zur Zeit geschlossen.",
        "overnightIndicator": "bis nächster Tag",
    },
    "es": {
        "open": "Öffnen",
        "isOpen": "Offen",
        "close": "Schliessen",
        "isClosed": "Geschlossen",
        "isAvailable": "Verfügbar",
        "isNotAvailable": "Nicht verfügbar",
        "closedTemp": "Vorübergehend Geschlossen",
        "venueCurrentlyOpen": "Das Restaurant ist zur Zeit geöffnet.",
        "willCloseAt": "Schliesst regulär heute um {{ todaysCloseTime }}",
        "willOpenAt": "Öffnet regulär wieder morgen um {{ todaysOpenTime }}",
        "venueCurrentlyClosed": "Das Restaurant ist zur Zeit geschlossen.",
        "overnightIndicator": "bis nächster Tag",
    }
}